import {Box, SelectChangeEvent} from "@mui/material";
import {useOutletContext} from "react-router-dom";
import {MaterialContextProps} from "pages/Material/types";
import PaginationControls from "./PaginationControls";
import RowsPerPageSelector from "./RowsPerPageSelector";
import PaginationInfo from "./PaginationInfo";
import {ChangeEvent} from "react";
import Grid from "@mui/material/Grid2";

interface PaginationProps {
  totalCount: number;
}

const Pagination = ({totalCount}: PaginationProps) => {
  const {page, setPage, limit, setLimit} = useOutletContext<MaterialContextProps>();

  const handlePageChange = (event: ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handleRowsPerPageChange = (event: SelectChangeEvent<number>) => {
    setLimit(Number(event.target.value));
    setPage(1)
  };

  const startItem = (page - 1) * limit + 1;
  const endItem = Math.min(page * limit, totalCount);

  return (
    <Grid container rowSpacing={2} alignItems={'center'}>
      <Grid size={{xxs: 0, md: 4}}/>
      <Grid size={{xxs: 12, sm: 6, md: 4}} display={{xxs: 'flex', md: 'block'}} justifyContent={'center'}>
        <PaginationControls
          count={Math.ceil(totalCount / limit)}
          page={page}
          onPageChange={handlePageChange}
        />
      </Grid>
      <Grid size={{xxs: 12, sm: 6, md: 4}} display={{xxs: 'flex', md: 'block'}} justifyContent={'center'}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
        }}>
          <RowsPerPageSelector limit={limit} onLimitChange={handleRowsPerPageChange}/>
          <PaginationInfo startItem={startItem} endItem={endItem} totalCount={totalCount}/>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Pagination;
